import { render } from "./AuthoringConversation.vue?vue&type=template&id=2091f6d0&scoped=true"
import script from "./AuthoringConversation.vue?vue&type=script&lang=js"
export * from "./AuthoringConversation.vue?vue&type=script&lang=js"

import "./AuthoringConversation.vue?vue&type=style&index=0&id=2091f6d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2091f6d0"]])

export default __exports__